
import { TenantName } from '../types/tenant.types';
import { getApiEndpoint } from './apiConfig';

export interface TerriaConfig {
  initializationUrls: string[];
  parameters: {
    googleUrlShortenerKey?: string;
    bingMapsKey?: string;
  };
}

const DEFAULT_CONFIG: TerriaConfig = {
  initializationUrls: [],
  parameters: {}
};

export class ConfigLoader {
  private static configCache: Map<TenantName, TerriaConfig> = new Map();

  static async loadTerriaConfig(projectName: TenantName): Promise<TerriaConfig> {
    if (this.configCache.has(projectName)) {
      return this.configCache.get(projectName)!;
    }

    try {
      const response = await fetch(
        getApiEndpoint(`config/${projectName}/config.json`)
      );

      if (response.ok) {
        const config = await response.json();
        this.configCache.set(projectName, config);
        return config;
      }
    } catch (error) {
      console.warn(`Failed to load config for ${projectName}:`, error);
    }

    this.configCache.set(projectName, DEFAULT_CONFIG);
    return DEFAULT_CONFIG;
  }

  static getCatalogUrl(projectName: TenantName): string {
    return getApiEndpoint(`config/${projectName}/catalogs/catalog_all.json`);
  }

  static clearCache(): void {
    this.configCache.clear();
  }
}